// extracted by mini-css-extract-plugin
export default {"main":"_1f10e9ce23","tit":"_89e137e874","maintitle":"dc3a71a490","ylw":"a0c228ecfb","white":"cefcc73d0e","mv_title":"ea0f40b09e","mv_nc":"bbc3c14c0c","mv_in":"d2820d4f86"};